<div
	class="bp-how-to builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"
>
	<div
		class="bp-how-to-holder builder-default-layout"
		[style.max-width]="desktopWidth + 'px'"
	>
		<div class="how-to-row" [class.dense]="trustedHowTo.length > 2">
			<div class="how-to-col"
				*ngFor="let how_to of trustedHowTo"
			>
				<div class="image-side" *ngIf="how_to.thumbnail && how_to.thumbnail.url" cols="4">
					<img
						class="card-image"
						[src]="how_to.thumbnail.url"
						:lazy-src="how_to.thumbnail.thumb_url"
						[alt]="how_to.thumbnail.custom_properties.alt_text"
						[height]="how_to.thumbnail.height"
						[width]="how_to.thumbnail.width"
					>
				</div>
				<div class="text-side">
					<div class="desc" [innerHTML]="how_to.trustedDesc"></div>
				</div>
			</div>
		</div>
	</div>
</div>